import { ALL_TIME_HIGH_LOW, ALL_TIME_HIGH_LOW_STREAM, } from "../../../interface/iAllTimeHighLow";
import { drivingMarketStreamingUpdate, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
};
const allTimeHighLow = (state = initState, action) => {
    switch (action.type) {
        case ALL_TIME_HIGH_LOW:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case ALL_TIME_HIGH_LOW_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default allTimeHighLow;
